import React, { useState } from 'react';
import { X } from 'lucide-react';
export function Footer() {
  const [modalContent, setModalContent] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-darkslate text-gray-400 py-8 px-4 text-center pb-32" data-id="element-27">
        <div className="max-w-md mx-auto" data-id="element-28">
          <p className="font-bold text-white mb-4" data-id="element-29">Método Cortisol Zero</p>
          <div className="flex justify-center gap-4 text-xs mb-6" data-id="element-30">
            <button onClick={() => setModalContent('privacy')} className="hover:text-white transition-colors underline" data-id="element-31">
              Política de Privacidad
            </button>
            <button onClick={() => setModalContent('terms')} className="hover:text-white transition-colors underline" data-id="element-32">
              Términos de Servicio
            </button>
          </div>
          <p className="text-[10px] opacity-60" data-id="element-33">
            Copyright 2024 - Método Cortisol Zero. Todos los derechos
            reservados. Este sitio no es parte del sitio web de Facebook o
            Facebook Inc. Además, este sitio NO está respaldado por Facebook de
            ninguna manera. FACEBOOK es una marca comercial de FACEBOOK, Inc.
          </p>
        </div>
      </footer>

      {/* Modal */}
      {modalContent && <div className="fixed inset-0 z-[60] bg-black/60 flex items-center justify-center p-4 backdrop-blur-sm" data-id="element-34">
          <div className="bg-white rounded-2xl w-full max-w-md max-h-[80vh] flex flex-col overflow-hidden animate-in fade-in zoom-in duration-200" data-id="element-35">
            <div className="flex justify-between items-center p-4 border-b border-gray-100" data-id="element-36">
              <h3 className="font-bold text-darkslate" data-id="element-37">
                {modalContent === 'privacy' ? 'Política de Privacidad' : 'Términos de Servicio'}
              </h3>
              <button onClick={() => setModalContent(null)} className="p-1 bg-gray-100 rounded-full text-gray-500 hover:text-darkslate" data-id="element-38">
                <X className="w-5 h-5" data-id="element-39" />
              </button>
            </div>
            <div className="p-4 overflow-y-auto text-sm text-gray-600 space-y-4" data-id="element-40">
              {modalContent === 'privacy' ? <>
                  <p data-id="element-41">
                    Tu privacidad es importante para nosotros. Es política de
                    Método Cortisol Zero respetar tu privacidad con respecto a
                    cualquier información que podamos recopilar.
                  </p>
                  <p data-id="element-42">
                    Solo solicitamos información personal cuando realmente la
                    necesitamos para brindarte un servicio. La recopilamos por
                    medios justos y legales, con tu conocimiento y
                    consentimiento.
                  </p>
                  <p data-id="element-43">
                    No compartimos ninguna información de identificación
                    personal públicamente ni con terceros, excepto cuando lo
                    exija la ley.
                  </p>
                </> : <>
                  <p data-id="element-44">
                    Al acceder a este producto, aceptas estar sujeto a estos
                    términos de servicio, a todas las leyes y regulaciones
                    aplicables.
                  </p>
                  <p data-id="element-45">
                    Los materiales de Método Cortisol Zero se proporcionan "tal
                    cual". No otorgamos garantías, expresas o implícitas, y por
                    la presente renunciamos y negamos todas las demás garantías.
                  </p>
                  <p data-id="element-46">
                    Este producto es de carácter informativo y no reemplaza la
                    consulta con un profesional de la salud.
                  </p>
                </>}
            </div>
            <div className="p-4 border-t border-gray-100" data-id="element-47">
              <button onClick={() => setModalContent(null)} className="w-full bg-gray-100 text-darkslate font-semibold py-2 rounded-xl" data-id="element-48">
                Cerrar
              </button>
            </div>
          </div>
        </div>}
    </>;
}